import gql from "graphql-tag";

export const updateExpertById = gql`
  mutation UpdateExpertById($data: UserUpdateInput!, $id: ID!) {
    updateUser(data: $data, where: { id: $id }) {
      id
    }
  }
`;
